<template>
  <div class="info2_box">
    <!-- <div>{{tx_id}}</div> -->
    <div class="title">{{info_data.title}}</div>
    <div class="time">{{time_format(info_data.update_time)}}</div>
    <div class="no_data" v-if="!info_data.tx_id">
        <img src="../../assets/img/no_data.png">
    </div>
    <div class="main_box" v-else>
        <!-- 联系信息 -->
        <div class="title" v-if="info_data.contact">{{$t('main.contact')}}</div>
        <div class="mr4" v-if="info_data.contact">
            <div class="mr4_lift">
            <div><img class="mr4_img2" src="../../assets/img/img2.png" alt=""></div>
            <div>
                <div class="mr4_1">{{info_data.contact}}</div>
                <!-- <div class="mr4_2">{{$t('main.manager')}}</div> -->
            </div>
            </div>
            <div v-if="info_data.phone_number">
                <img class="mr4_img3" @click="open_phone(info_data.phone_number)" src="../../assets/img/img3.png" alt="">
            </div>
        </div>
        <div class="des m_bottom" v-if="info_data.location">
            <i class="el-icon-location-outline dt"></i>
            {{info_data.location}}
        </div>

        <div v-html="info_data.content"></div>
    </div>
  </div>
</template>

<script>
import { webDetails } from '@/api/api';

export default {
    data(){
        return{
            language:'',
            tx_id:'',
            info_data:[],
        }
    },
    beforeMount(){
      const queryString = window.location.search;
        if(queryString){
            // ?language=ch&tx_id=e7682c628e63416391d91534a27410d0
            const urlParams = new URLSearchParams(queryString);
            const lang = urlParams.get('language');
            const tx_id = urlParams.get('tx_id');
            if(lang&&tx_id){
                this.$i18n.locale = lang;
                this.language = lang;
                this.tx_id = tx_id;
            }
        }
    },
    mounted(){
        if(!this.language || !this.tx_id) return;
        this.get_list();
    },
    methods:{
        async get_list() {
            const res = await webDetails({
                tx_id:this.tx_id,
                language:this.language
            });
            if(res.data.code!=200){
                return this.$toast(res.data.msg);
            }
            this.info_data = res.data.data;
        },
        open_phone(phone){
            if(!phone) return false;
            if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
                if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callPhone) {
                    window.webkit.messageHandlers.callPhone.postMessage(phone);
                } else {
                    console.error("window.webkit is not defined");
                }
            } else if (navigator.userAgent.match(/android/i)) {
                if (window.CASATask && typeof window.CASATask.callPhone === 'function') {
                    window.CASATask.callPhone(phone);
                } else {
                    console.error("CASATask interface is not available.");
                }
            }
        }

    }
}
</script>

<style scoped>
.info2_box{
    min-height: 100vh;
    background: #EEEEEE;
    box-sizing: border-box;
    padding: 18px 16px 20px;
}
.title{
    font-size: 20px;
    font-weight: bold;
}
.time{
    font-size: 12px;
    color: #888;
    margin-top: 4px;
}
.main_box{
    margin-top: 10px;
}
.main_box img,
.main_box >>> img{
    max-width: 100%;
}
.no_data{
    display: flex;
    height: 75vh;
}
.no_data img{
    width: 120px;
    margin: auto;
}
/* ---- */
.mr4{
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mr4_img2{
  width: 35px;
  margin: 0 12px;
}
.mr4_1{
  font-size: 15px;
  font-weight: bold;
  margin-top: -5px;
}
.mr4_2{
  color: #888;
  font-size: 10px;
}
.mr4_img3{
  width: 35px;
}
.mr4_lift{
  display: flex;
  align-items: center;
}
.mr4_img3:first-child{
  margin-right: 12px;
}
.des{
  margin-top: 12px;
  color: #888;
  font-size: 10px;
}
.m_bottom{
    padding-bottom: 15px;
}

</style>
